import WebApiService from "@/services/webapi.service.js";


import moment from 'moment';
import 'moment/locale/it';
moment.locale('it');

export const apiMixin = {

    methods:{

        doApiCall: function(method, url, token, params = null, data= null){

            if(method == "get"){

                return WebApiService.get(url, token, params).then(
                    
                    (data) => {                                        
                        if(data.StatusCode == 401){
                            this.$router.push("/");
                        }
                        else if (data.StatusCode == 200){
                            return data.Data;
                        }
                        else{                            
                            console.log(data.Message);
                            return null;
                        }
                    },

                    (error) => {
                        console.log(error);
                    }
                );
            }
            if(method == "getImg"){

                return WebApiService.getImage(url, token, params).then(
                    (data) => { 
                                                            
                        if(data.status == 401){
                            this.$router.push("/");
                        }
                        else if (data.status == 200){                           
                            return data.data;
                        }
                        else{                            
                            console.log(data.Message);
                            return null;
                        }                      
                    },

                    (error) => {
                        console.log(error);
                    }
                );
            }
            if(method == "post"){

                return WebApiService.post(url, token, data, params).then(

                    (data) => {                       
                        if(data.StatusCode == 401){
                            this.$router.push("/");
                        }
                        else if (data.StatusCode == 200){
                            return data;
                        }
                        else{                          
                            this.$toast.error("Attenzione! Si sono verificati errori durante l'esecuzione della richista: " + data.Message, {position:"top-right"});
                            return null;
                        }
                    },

                    (error) => {
                        console.log(error);
                    }
                );
            }

        }
    }
}

export const interventiMixin = {

    methods: {
          /** @type {FiltroModelliEventData} */
            filtraInterventi: function(filterData){
            this.listaInterventi = this.listaInterventiOriginale;
            this.listaInterventi = this.listaInterventi.filter(item => {  
                let cond = true;               
                if( filterData.StatoIntervento){
                    cond = cond && item.CodiceStato === filterData.StatoIntervento || filterData.StatoIntervento === "all";
                }
                if(filterData.SitoIntervento){
                    cond = cond && (item.CodiceSito === filterData.SitoIntervento || filterData.SitoIntervento === "all");
                }
                if(filterData.DataIntervento){
                    let d = moment(item.DataDaEffettuarsiEntro).format('YYYY-MM-DD');
                    cond = cond && d <= filterData.DataIntervento;
                }             
                
                return cond;
            });
        },
        rimuoviFiltri: function(){
            this.listaInterventi = this.listaInterventiOriginale;
        }
    },
    data(){
        return {
            listaInterventiOriginale: [],
            listaInterventi: []
        }
    }
}

export const scadenzariMixin = {
    methods:{
        filtraScadenzari: function(filterData){
        
            this.listaScadenzario = this.listaScadenzarioOriginale;
            this.listaScadenzario = this.listaScadenzario.filter(item=>{

                let cond  = true;               
                if(filterData.SitoIntervento){
                    cond = cond && (item.CodiceSito === filterData.SitoIntervento || filterData.SitoIntervento === "all");
                }
                
                if(filterData.RepartoIntervento){

                    cond = cond && (item.TokReparto.toLowerCase().includes(filterData.RepartoIntervento.toLowerCase()) || filterData.RepartoIntervento === "all");
                } 

                if(filterData.EntitaIntervento){
                    cond = cond && (item.CodiceEntita === filterData.EntitaIntervento || filterData.EntitaIntervento === "all");
                }  
                
                if(filterData.UnitaIntervento){
                    cond = cond && (item.GlbUnita.split('~|~')[2] === filterData.UnitaIntervento || filterData.UnitaIntervento === "all");
                }  

                if(filterData.DataFinoA){
                    let d = moment(item.DataProssima).format('YYYY-MM-DD');
                    cond = cond && d <= filterData.DataFinoA;
                }
                return cond;              
            });
        },

        rimuoviFiltri: function(){
            this.listaScadenzario = this.listaScadenzarioOriginale;
        }
    },
    data(){
        return {
            listaScadenzarioOriginale: [],
            listaScadenzario:[]
        }
    }
}

export const entitaMixin = {
    methods:{
        filtraEntita: function(filterData){         
            this.listaEntita = this.listaEntitaOriginale;
            this.listaEntita = this.listaEntita.filter(item=>{             
                let cond  = true;               
                if(filterData.SitoEntita){
                    cond = cond && (item.CodiceSito === filterData.SitoEntita || filterData.SitoEntita === "all");
                }
                            
                return cond;              
            });
        },
        rimuoviFiltri: function(){
            this.listaEntita = this.listaEntitaOriginale;
        }
    },
    data(){
        return {
            listaEntitaOriginale: [],
            listaEntita:[]
        }
    }
}

export const contrattiMixin = {
    methods:{
        filtraContratti: function(filterData){         
            this.listaContratti = this.listaContrattiOriginale;
            this.listaContratti = this.listaContratti.filter(item => {

                let cond  = true;               
                if(filterData.StatoIntervento){
                    cond = cond && (item.CodiceStato === filterData.StatoIntervento || filterData.StatoIntervento === "all");
                }
                
                return cond;              
            });
        },
        rimuoviFiltri: function(){
            this.listaContratti = this.listaContrattiOriginale;
        }
    },
    data(){
        return {
            listaEntitaOriginale: [],
            listaEntita:[]
        }
    }
}

export const griglieInterventiMixin = {

    methods: {
        gestisciTabDettagli: function(el, index, elementId, openClass, closeClass){
            $("#" + elementId + index).slideToggle('fast');
            $(el).toggleClass('Open').toggleClass('Close');
            $(el).parent().parent().parent().toggleClass(openClass).toggleClass(closeClass);  
        
            
        },
        mostraDettagli: function(index, codiceIntervento, chiaveIntervento, e){
        
            this.chiaveIntervento = chiaveIntervento;
            var el = e.srcElement.parentElement; 
            
            if($(el).parent().parent().parent().hasClass('ChiusuraDettagli')){
                this.isClosingDett = true;               
            }  
            else{
                this.isClosingDett = false;               
            }
            this.gestisciTabDettagli(el, index, "pannDett", 'AperturaDettagli', 'ChiusuraDettagli');
        }
    }
}

export const dateMixin = {
    methods:{
        formatDate: function(date, format = 'DD/MM/YYYY HH:mm') {    
            let d = moment(date).format(format);     
            if(d == "Invalid date")d = "-";
            return d;      
        },
        formatDateNoOre: function(date, format = 'DD/MM/YYYY') {    
            let d = moment(date).format(format);     
            if(d == "Invalid date")d = "-";
            return d;      
        },
        formatDateNoOreJQuery: function(date, format = 'YYYY-MM-DD') {    
            let d = moment(date).format(format);   
            if(d == "Invalid date")d = "-";   
            return d ;      
        }             
    }
}

export const numberMixin = {
    methods:{
        number_format(number, decimals, dec_point, thousands_sep) {           
            var n = !isFinite(+number) ? 0 : +number, 
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                toFixedFix = function (n, prec) {
                    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                    var k = Math.pow(10, prec);
                    return Math.round(n * k) / k;
                },
                s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }
    }
}

export const StatoInterventoEntitaMixin = {
    methods:{
        decod_stato(stato){
            if(stato === true){
                return "Eseguito";               
            }else{
                return "Non Eseguito";
            }
        }
    }
}